/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedAppsRouteImport } from './routes/_authed/apps'
import { Route as AuthedTemplatesIndexRouteImport } from './routes/_authed/templates.index'
import { Route as AuthedPlayersIndexRouteImport } from './routes/_authed/players.index'
import { Route as AuthedCampaignsIndexRouteImport } from './routes/_authed/campaigns.index'
import { Route as AuthedTemplatesNewRouteImport } from './routes/_authed/templates.new'
import { Route as AuthedTemplatesTemplateIdRouteImport } from './routes/_authed/templates.$templateId'
import { Route as AuthedPlayersPlayerIdRouteImport } from './routes/_authed/players.$playerId'
import { Route as AuthedCampaignsNewRouteImport } from './routes/_authed/campaigns.new'
import { Route as AuthedCampaignsCampaignIdRouteImport } from './routes/_authed/campaigns.$campaignId'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAppsRoute = AuthedAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTemplatesIndexRoute = AuthedTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPlayersIndexRoute = AuthedPlayersIndexRouteImport.update({
  id: '/players/',
  path: '/players/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsIndexRoute = AuthedCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTemplatesNewRoute = AuthedTemplatesNewRouteImport.update({
  id: '/templates/new',
  path: '/templates/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTemplatesTemplateIdRoute =
  AuthedTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPlayersPlayerIdRoute = AuthedPlayersPlayerIdRouteImport.update({
  id: '/players/$playerId',
  path: '/players/$playerId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsNewRoute = AuthedCampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsCampaignIdRoute =
  AuthedCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/apps': typeof AuthedAppsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/campaigns/$campaignId': typeof AuthedCampaignsCampaignIdRoute
  '/campaigns/new': typeof AuthedCampaignsNewRoute
  '/players/$playerId': typeof AuthedPlayersPlayerIdRoute
  '/templates/$templateId': typeof AuthedTemplatesTemplateIdRoute
  '/templates/new': typeof AuthedTemplatesNewRoute
  '/campaigns/': typeof AuthedCampaignsIndexRoute
  '/players/': typeof AuthedPlayersIndexRoute
  '/templates/': typeof AuthedTemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/apps': typeof AuthedAppsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/campaigns/$campaignId': typeof AuthedCampaignsCampaignIdRoute
  '/campaigns/new': typeof AuthedCampaignsNewRoute
  '/players/$playerId': typeof AuthedPlayersPlayerIdRoute
  '/templates/$templateId': typeof AuthedTemplatesTemplateIdRoute
  '/templates/new': typeof AuthedTemplatesNewRoute
  '/campaigns': typeof AuthedCampaignsIndexRoute
  '/players': typeof AuthedPlayersIndexRoute
  '/templates': typeof AuthedTemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authed/apps': typeof AuthedAppsRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/campaigns/$campaignId': typeof AuthedCampaignsCampaignIdRoute
  '/_authed/campaigns/new': typeof AuthedCampaignsNewRoute
  '/_authed/players/$playerId': typeof AuthedPlayersPlayerIdRoute
  '/_authed/templates/$templateId': typeof AuthedTemplatesTemplateIdRoute
  '/_authed/templates/new': typeof AuthedTemplatesNewRoute
  '/_authed/campaigns/': typeof AuthedCampaignsIndexRoute
  '/_authed/players/': typeof AuthedPlayersIndexRoute
  '/_authed/templates/': typeof AuthedTemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/apps'
    | '/dashboard'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/players/$playerId'
    | '/templates/$templateId'
    | '/templates/new'
    | '/campaigns/'
    | '/players/'
    | '/templates/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/apps'
    | '/dashboard'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/players/$playerId'
    | '/templates/$templateId'
    | '/templates/new'
    | '/campaigns'
    | '/players'
    | '/templates'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/sign-in'
    | '/_authed/apps'
    | '/_authed/dashboard'
    | '/_authed/campaigns/$campaignId'
    | '/_authed/campaigns/new'
    | '/_authed/players/$playerId'
    | '/_authed/templates/$templateId'
    | '/_authed/templates/new'
    | '/_authed/campaigns/'
    | '/_authed/players/'
    | '/_authed/templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/apps': {
      id: '/_authed/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthedAppsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/templates/': {
      id: '/_authed/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthedTemplatesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/players/': {
      id: '/_authed/players/'
      path: '/players'
      fullPath: '/players/'
      preLoaderRoute: typeof AuthedPlayersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns/': {
      id: '/_authed/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthedCampaignsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/templates/new': {
      id: '/_authed/templates/new'
      path: '/templates/new'
      fullPath: '/templates/new'
      preLoaderRoute: typeof AuthedTemplatesNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/templates/$templateId': {
      id: '/_authed/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AuthedTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/players/$playerId': {
      id: '/_authed/players/$playerId'
      path: '/players/$playerId'
      fullPath: '/players/$playerId'
      preLoaderRoute: typeof AuthedPlayersPlayerIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns/new': {
      id: '/_authed/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof AuthedCampaignsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns/$campaignId': {
      id: '/_authed/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof AuthedCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAppsRoute: typeof AuthedAppsRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedCampaignsCampaignIdRoute: typeof AuthedCampaignsCampaignIdRoute
  AuthedCampaignsNewRoute: typeof AuthedCampaignsNewRoute
  AuthedPlayersPlayerIdRoute: typeof AuthedPlayersPlayerIdRoute
  AuthedTemplatesTemplateIdRoute: typeof AuthedTemplatesTemplateIdRoute
  AuthedTemplatesNewRoute: typeof AuthedTemplatesNewRoute
  AuthedCampaignsIndexRoute: typeof AuthedCampaignsIndexRoute
  AuthedPlayersIndexRoute: typeof AuthedPlayersIndexRoute
  AuthedTemplatesIndexRoute: typeof AuthedTemplatesIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAppsRoute: AuthedAppsRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedCampaignsCampaignIdRoute: AuthedCampaignsCampaignIdRoute,
  AuthedCampaignsNewRoute: AuthedCampaignsNewRoute,
  AuthedPlayersPlayerIdRoute: AuthedPlayersPlayerIdRoute,
  AuthedTemplatesTemplateIdRoute: AuthedTemplatesTemplateIdRoute,
  AuthedTemplatesNewRoute: AuthedTemplatesNewRoute,
  AuthedCampaignsIndexRoute: AuthedCampaignsIndexRoute,
  AuthedPlayersIndexRoute: AuthedPlayersIndexRoute,
  AuthedTemplatesIndexRoute: AuthedTemplatesIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
